<template>
    <div
         :id="'pm-gallery-media-grid-thumb-' + item.id"
         :key="item.id"
         :data-src="item.src"
         :data-id="item.id"
         class="editable pm-gallery-media-grid-thumb"
         :style="'background-image: url(' + thumbSrc + ')'"
         @click="$emit('click')"
    >
        <!--mdi style="-webkit-filter: drop-shadow( 1px 1px 0px rgba(0, 0, 0, .3)); filter: drop-shadow( 1px 1px 0px rgba(0, 0, 0, .3)); border-radius: 4px; padding: 7px 7px 5px 5px; opacity: 1; color: #ddd; right: 1px; top: 1px; position: absolute;" :size="28">arrow-expand</mdi-->
        <slot></slot>
    </div>
</template>
<style>
    .pm-gallery-media-grid-thumb {
        position: relative;
        background-color: #eee;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 3px;
        box-shadow: 3px 3px 1px rgba(0,0,0,.08);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .pm-gallery-grid-4 .pm-gallery-media-grid-thumb {
        height: Calc(100vw / 3 - 24px);
    }
    .pm-gallery-grid-3 .pm-gallery-media-grid-thumb {
        height: Calc(100vw / 3 - 24px);
    }
    .pm-gallery-grid-2 .pm-gallery-media-grid-thumb {
        height: Calc((100vw / 2) - 32px);
    }
    .pm-gallery-grid-1 .pm-gallery-media-grid-thumb {
        height: Calc(100vw - 32px);
    }
</style>
<script>
export default {
    props: {
        item: {

        },
    },
    computed: {
        thumbSrc() {
            const rootUrl = "https://cdn.denticalc.com/photos/";
            const grid = localStorage.getItem('galleryGrid') ? localStorage.getItem('galleryGrid') : 4;
            if (grid <= 2) return rootUrl + this.item.src.replace('.jpg','_thumb_guetzli.jpg');
            return rootUrl + this.item.src.replace('.jpg','_thumb_xs_guetzli.jpg');

            //:style="'background-image: url(\'https://cdn.denticalc.com/photos/'+ item.src.replace('.jpg','_thumb_guetzli.jpg') + '\')'"
        },
    }
};
</script>
